import { ENGT_CHAT } from 'js/bot.model';
import './dropdown.scss';

export class Dropdown {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(props) {
		this.data = {};
		this.setter({
			...props,
			label: props.title,
			id: props.id,
			name: props.name,
			options: props.options,
			payload: props.payload,
		});
	}

	initWrapper() {
		const { id, label } = this.data;
		const dropdown = document.createElement('div');
		dropdown.classList.add('engt-dropdown');

		const dropdownLabel = document.createElement('span');
		dropdownLabel.classList.add('engt-dropdown-label');
		dropdownLabel.innerHTML = label;
		dropdown.appendChild(dropdownLabel);
		this.addDropdownOptions(dropdown, this.data);
		if (id) dropdown.id = id;

		this.html = dropdown;
	}

	initEventHandlers() {
		const dropdownElements = this.html.querySelectorAll('.engt-dropdown-options-wrapper');
		if (dropdownElements?.length) {
			const dropdownList = Array.from(dropdownElements);
			dropdownList.map((option) => {
				option.addEventListener('change', (selection) => {
					const values = { ...ENGT_CHAT.get('carouselDropdowns') } || {};
					values[`${option.name}`] = selection.target.value;
					ENGT_CHAT.set('carouselDropdowns', values);
				});
			});
		}
	}

	addDropdownOptions(dropdown, data) {
		const { id, options, name } = data;
		try {
			let optionsData = options;
			if (optionsData?.length) {
				const dropdownOptions = document.createElement('select');
				dropdownOptions.setAttribute('name', `${this.data.msgId}-${id}-${name}`);
				dropdownOptions.setAttribute('id', `${this.data.msgId}-${id}-${name}`);
				dropdownOptions.classList.add('engt-dropdown-options-wrapper');
				const initValues = { ...ENGT_CHAT.get('carouselDropdowns') } || {};

				if (typeof optionsData[0] !== 'object') {
					optionsData = optionsData.map((option) => ({
						id: option,
						label: option,
					}));
				}
				optionsData.map((option) => {
					const optionElement = document.createElement('option');
					optionElement.value = option.id;
					optionElement.innerHTML = option.label;
					dropdownOptions.appendChild(optionElement);
				});
				initValues[`${this.data.msgId}-${id}-${name}`] = optionsData[0]?.id;
				ENGT_CHAT.set('carouselDropdowns', initValues);
				dropdown.appendChild(dropdownOptions);
			}
		} catch (e) {
			console.error('JSON processing error in dropdown options: ', e);
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
